/** Default district key used for file pre-selection when no district is explicitly assigned. */
export const DEFAULT_DISTRICT_KEY = 'fl_middle';

export { default as listDistrictTemplates, useDistrictTemplates } from './listDistrictTemplates';
export {
  default as getDistrictTemplateById,
  useDistrictTemplate,
  type DistrictTemplateFilters,
} from './getDistrictTemplateById';
export { default as getDistrictTemplateByKey, useDistrictTemplateByKey } from './getDistrictTemplateByKey';
